import { memo } from 'react'
import _get from 'lodash/get'
import { getFirstLetter } from 'core/common/utils/string'
import { StyledAvatar } from './style'
import { TOptionsWithAvatarProps } from './types'

const VariationAvatar = ({ option, showAvatar }: TOptionsWithAvatarProps) => {
  if (!showAvatar) {
    return null
  }

  const color = _get(option, 'color')
  const firstLetter = getFirstLetter(option.title)

  return (
    <StyledAvatar className="ml-1" data-testid={color || firstLetter} color={color}>
      {!color && firstLetter}
    </StyledAvatar>
  )
}

export default memo(VariationAvatar)
